import {ValidationModel} from '../../../shared/models/validation-results/validation.model';

import * as moment from 'moment';

export class DisbursementSummaryModel extends ValidationModel {

    public financeDisbursementRequestId: number;
    public customerNumberId: number;
    public financeDisbursementRequestStatusTypeDisplayValue: string;
    public financeDisbursementRequestStatusTypeId: number;
    public financeDisbursementRequestTypeId: number;
    public financeDisbursementRequestTypeDisplayValue: string;
    public amount: number;
    public createdDate: Date;
    public createdDateDisplay: string;
    public createdBy: string;
    public approvedDate: Date;
    public approvedDateDisplay: string;
    public approvedBy: string;
    public editedDate: Date;
    public editedDateDisplay: string;
    public editedBy: string;
    public updatedDate: Date;
    public updatedDateDisplay: string;
    public checkNumber: string;
    public comment: string;
    public nameDisplayValue: string;
    public customerAccountNumberId: number;
    public addressDisplayValue: string;
    public legacyCustomerNumber: string;
    public legacySequenceNumber: string;
    public issuedDate: Date;
    public issuedDateDisplay: string;
    public directToCreditCard: boolean;
    public authorizationCode: string;
    public orderNumber: number;
    public assignedToUserName: string;
    public receivedDate: Date;
    public receivedDateDisplay: string;
    public daysOpen: number;
    public periodRangeDisplayValue: string;
    public deniedBy: string;
    public deniedDate: Date;
    public canUpdateAssignedTo: boolean;

    /**
     * Constructor
     * @param json The json object containing the summary data
     */
    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.financeDisbursementRequestId = json.financeDisbursementRequestId;
            this.customerNumberId = json.customerNumberId;
            this.financeDisbursementRequestStatusTypeId = json.financeDisbursementRequestStatusTypeId;
            this.financeDisbursementRequestStatusTypeDisplayValue = json.financeDisbursementRequestStatusTypeDisplayValue;
            this.financeDisbursementRequestTypeId = json.financeDisbursementRequestTypeId;
            this.financeDisbursementRequestTypeDisplayValue = json.financeDisbursementRequestTypeDisplayValue;
            this.amount = json.amount;
            this.createdDate = json.createdDate ? new Date(json.createdDate) : undefined;
            this.createdDateDisplay = json.createdDate ? moment(json.createdDate).format('MM/DD/YYYY') : '';
            this.createdBy = json.createdBy;
            this.approvedDate = json.approvedDate ? new Date(json.approvedDate) : undefined;
            this.approvedDateDisplay = json.approvedDate ? moment(json.approvedDate).format('MM/DD/YYYY') : '';
            this.approvedBy = json.approvedBy;
            this.editedDate = json.editedDate ? new Date(json.editedDate) : undefined;
            this.editedDateDisplay = json.editedDate ? moment(json.editedDate).format('MM/DD/YYYY') : '';
            this.editedBy = json.editedBy;
            this.updatedDate = json.approvedDate ? new Date(json.updatedDate) : undefined;
            this.updatedDateDisplay = json.updatedDate ? moment(json.updatedDate).format('MM/DD/YYYY') : '';
            this.checkNumber = json.checkNumber;
            this.comment = json.comment;
            this.nameDisplayValue = json.nameDisplayValue;
            this.customerAccountNumberId = json.customerAccountNumberId;
            this.addressDisplayValue = json.addressDisplayValue;
            this.legacyCustomerNumber = json.legacyCustomerNumber;
            this.legacySequenceNumber = json.legacySequenceNumber;
            this.issuedDate = json.issuedDate ? new Date(json.issuedDate) : undefined;
            this.issuedDateDisplay = json.issuedDate ? moment(json.issuedDate).format('MM/DD/YYYY') : '';
            this.directToCreditCard = json.directToCreditCard;
            this.authorizationCode = json.authorizationCode;
            this.orderNumber = json.orderNumber;
            this.assignedToUserName = json.assignedToUserName;
            this.receivedDate = json.receivedDate ? new Date(json.receivedDate) : undefined;
            this.receivedDateDisplay = json.receivedDate ? moment(json.receivedDate).format('MM/DD/YYYY') : '';
            this.daysOpen = json.daysOpen;
            this.periodRangeDisplayValue = json.periodRangeDisplayValue;
            this.deniedBy = json.deniedBy;
            this.deniedDate = json.deniedDate;
            this.canUpdateAssignedTo = json.canUpdateAssignedTo;
        }
    }
}
